import { useRouter } from "next/router";
import { getLocale } from "@/functions/getLocale";

export const useLocale = () => {
    const router = useRouter();

    return getLocale(router.asPath);
};